import Vue from 'vue'
import Router from 'vue-router'
import Live from '@/views/Live'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/videos/',
      name: 'videos',
      component: Live
    },
    {
      path: '/videos/:slug',
      name: 'video',
      component: Live
    },
    {
      path: '/media/videos/:slug',
      name: 'media',
      component: Live
    },
    {
      path: '/media/video/:slug',
      name: 'media-2',
      component: Live
    }
  ]
})
